<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/8hW81i/tc-custom/9781504094344.jpg?1737195128120" alt="This image is the cover for the book Lunch with the Deadly Dozen"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Lunch with the Deadly Dozen
      </h1>
      <p class="bookDescription body article font2">
        <b>This group likes to stay active in retirement—by catching killers . . .</b><br/><br/> Widowed and in his sixties, Thomas Quinn has been asked to lunch by Lexington Smith, the leader of a covert team who call themselves The Twelve. When Quinn accepts the invitation to join the group, he finds himself united with other retired experts—from a surgeon to a locksmith to a cabbie—in a quest to capture a killer targeting homeless victims on London’s transit system.<br/><br/> As the body count rises, Quinn and his companions try to puzzle out a pattern. But can they protect this vulnerable population by identifying a predator amid the crowds of the London Underground?
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Peter Berry
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Bloodhound Books
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3a62611e